module.exports = __webpack_public_path__ + "img/logo-nph.a38ba7da.png";